/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';

/**
 * 
 * @export
 * @interface OrganizationMemberUpdateDTO
 */
export interface OrganizationMemberUpdateDTO {
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof OrganizationMemberUpdateDTO
     */
    role: OrganizationRoleDTO;
}



/**
 * Check if a given object implements the OrganizationMemberUpdateDTO interface.
 */
export function instanceOfOrganizationMemberUpdateDTO(value: object): value is OrganizationMemberUpdateDTO {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function OrganizationMemberUpdateDTOFromJSON(json: any): OrganizationMemberUpdateDTO {
    return OrganizationMemberUpdateDTOFromJSONTyped(json, false);
}

export function OrganizationMemberUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMemberUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'role': OrganizationRoleDTOFromJSON(json['role']),
    };
}

export function OrganizationMemberUpdateDTOToJSON(value?: OrganizationMemberUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': OrganizationRoleDTOToJSON(value['role']),
    };
}

